var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavFutures(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1102 11.7935H13.3308V22.2686H21.9999V14.6832H19.1102V11.7935ZM19.2161 15.8726L19.7268 16.3834L16.9429 19.1673L15.6039 17.8282L16.1147 17.3175L16.9429 18.1457L19.2161 15.8726Z",
    fill: "CurrentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8328 13.9607H22L19.8328 11.7935V13.9607Z",
    fill: "CurrentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7276 0.85H18.5776V1V1.63492V1.78492H18.7276H19.7406L7.65833 12.769C7.45739 12.6593 7.22726 12.596 6.98159 12.596C6.86563 12.596 6.75599 12.6129 6.65248 12.6394L1.66046 4.87412L1.57938 4.748L1.45322 4.82903L0.918936 5.1722L0.79268 5.2533L0.873822 5.37952L5.86517 13.1442C5.67712 13.384 5.56175 13.6852 5.56175 14.0159C5.56175 14.8 6.19747 15.4357 6.98159 15.4357C7.7657 15.4357 8.40143 14.8 8.40143 14.0159C8.40143 13.8172 8.35711 13.6316 8.28414 13.4635L20.4824 2.37401V3.53968V3.68968H20.6324H21.2673H21.4173V3.53968V1V0.85H21.2673H18.7276Z",
    fill: "CurrentColor",
    stroke: "CurrentColor",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29898 17.7383H6.66406V18.3732H7.29898V17.7383Z",
    fill: "CurrentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29898 16.5H6.66406V17.1349H7.29898V16.5Z",
    fill: "CurrentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29898 19.0078H6.66406V19.6427H7.29898V19.0078Z",
    fill: "CurrentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29898 20.2778H6.66406V20.9128H7.29898V20.2778Z",
    fill: "CurrentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.569 20.2778H7.93408V20.9128H8.569V20.2778Z",
    fill: "CurrentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83878 20.2778H9.20386V20.9128H9.83878V20.2778Z",
    fill: "CurrentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1086 20.2778H10.4736V20.9128H11.1086V20.2778Z",
    fill: "CurrentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3783 20.2778H11.7434V20.9128H12.3783V20.2778Z",
    fill: "CurrentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavFutures);
export default __webpack_public_path__ + "static/media/icon-nav-futures.2a168bea041f18c047cf6f0db58b6876.svg";
export { ForwardRef as ReactComponent };